<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		title?: Snippet;
		children?: Snippet;
	}

	const { title, children }: Props = $props();
</script>

<div class="flex w-full bg-neutral-weakest rd-2 flex-col gap-2 p-2">
	<div class="h-9 flex flex-row justify-between items-center text-md text-coloredneutral">
		{@render title?.()}
	</div>
	{@render children?.()}
</div>
